module.exports = __webpack_public_path__ + "img/greenLeft.6b1150b4.svg";